module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"urlText":"Url Cleaning"},"fr":{"urlText":"Nettoyage de vos URLs"},"de":{"urlText":"Url-Reinigung"}}')
  delete Component.options._Ctor
}
